import React, { Component } from 'react';
import { showSnackbar } from "../../Redux/actions/snackbar";
import { hideLoadingBar, showLoadingBar } from "../../Redux/actions/loading";
import { connect } from "react-redux";
import { PGService } from "../../Remote/PowerGym";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from "react-router-dom";
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Avatar from '@material-ui/core/Avatar';
import { withNamespaces } from 'react-i18next';


class ListSchedules extends Component {


    constructor(props) {
        super(props);

        this.state = {
            schedules: null,
            enabledSchedules: []
        }
    }


    componentDidMount() {
        this.props.showLoadingBar();

        PGService.getSchedules().then(response => {
            this.setState({
                schedules: response.data,
                enabledSchedules: response.enabled_schedules || [],
            });
            this.props.hideLoadingBar();
        });
    }

    render() {

        const { t } = this.props;

        const isEnabled = (current) => {
            return !this.state.enabledSchedules.find(function (element) {
                return element.schedule_id === current;
            });
        };

        return (
            <div>
                <h2>{t("Schedules Available")}</h2>
                {
                    this.state.schedules === null ? t("Loading") : ""
                }

                {
                    this.state.schedules && this.state.schedules.length === 0 ? t("No schedules") : ""
                }
                {this.state.schedules && <List>
                    {this.state.schedules.map((e) => {
                        let disabled = !!isEnabled(e.id);

                        let secondaryText = `${t("Weekly timetables quantity")}: ${e.timetable_qty}`;

                        if (disabled) {
                            secondaryText = t(`You are not subscribed to this activity`);
                        }


                        return (
                            <ListItem disabled={disabled} key={e.id} button component={Link} to={`/timetables/${e.id}`}>
                                <ListItemIcon>
                                    <Avatar>{e.detail.charAt(0).toUpperCase()}</Avatar>
                                </ListItemIcon>
                                <ListItemText
                                    primary={e.detail}
                                    secondary={secondaryText}
                                />
                            </ListItem>
                        );

                    })
                    }
                </List>}
            </div>
        );
    }

}


const mapStateToProps = (state) => ({
    loading: state.loading
});

const mapDispatchToProps = dispatch => ({
    showLoadingBar: () => dispatch(showLoadingBar()),
    hideLoadingBar: () => dispatch(hideLoadingBar()),
    showSnackbar: (message) => dispatch(showSnackbar(message))
});

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(ListSchedules));
